import type React from 'react';

interface NavigateToParams {
  url: string;
  clickEvent?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>;
  navigate: (path: string) => void;
}

export const navigateTo = ({ url, clickEvent, navigate }: NavigateToParams) => {
  if (clickEvent) {
    clickEvent.preventDefault();
    if (clickEvent.ctrlKey || clickEvent.metaKey) {
      window.open(url, '_blank');
      return;
    }
  }

  const urlObject = new URL(url, window.location.origin);
  const path = urlObject.pathname + urlObject.search + urlObject.hash;
  navigate(path);
};
